import { render, staticRenderFns } from "./ChangeOfProgrammeHistory.vue?vue&type=template&id=91685b50&scoped=true"
import script from "./ChangeOfProgrammeHistory.vue?vue&type=script&lang=js"
export * from "./ChangeOfProgrammeHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91685b50",
  null
  
)

export default component.exports